import { Switch, Route, useRouteMatch } from "react-router-dom";
import {
    ListMenuScreen,
    CreateMenuScreen,
    ShowMenuScreen,
    UpdateMenuScreen,
} from "../screens";
import routes from "./URL";
export default function gallery_image_routes() {
    return (
        <Switch>
             <Route
                exact
                path={routes.admin.menu.root(":hotelSlug")}
                component={ListMenuScreen}
            />
            <Route
                path={routes.admin.menu.create(":hotelSlug")}
                component={CreateMenuScreen}
            />

            <Route
                path={routes.admin.menu.update(":hotelSlug",":menuSlug",":categorySlug",":id")}
                component={UpdateMenuScreen}
            />
            <Route
                path={routes.admin.menu.show(":id")}
                component={ShowMenuScreen}
            />
           
            {/* <Route
                exact
                path={routes.admin.menu.root(":hotelSlug")}
                component={ListMenuScreen}
            /> */}
            {/* <Route exact path={"/"} component={ListGalleryScreen} /> */}
        </Switch>
    );
}
